
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const PasswordForm = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const { toast } = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const updatePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmNewPassword) {
      toast({
        title: t("profile.messages.error"),
        description: t("profile.messages.passwordsNotMatch"),
        variant: "destructive",
      });
      return;
    }

    try {
      const { error } = await supabase.auth.updateUser({ 
        password: newPassword 
      });

      if (error) throw error;

      toast({
        title: t("profile.messages.success"),
        description: t("profile.messages.passwordUpdated"),
      });
      
      setCurrentPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
      
      navigate("/");
    } catch (error: any) {
      toast({
        title: t("profile.messages.error"),
        description: error.message,
        variant: "destructive",
      });
    }
  };

  return (
    <form onSubmit={updatePassword} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="new-password">{t("profile.form.newPassword")}</Label>
        <Input
          id="new-password"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="confirm-password">{t("profile.form.confirmPassword")}</Label>
        <Input
          id="confirm-password"
          type="password"
          value={confirmNewPassword}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
        />
      </div>
      <Button type="submit">
        {t("profile.form.updatePassword")}
      </Button>
    </form>
  );
};
